import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { Resource, ResourceService } from '@klickdata/core/resource';
import { Observable } from 'rxjs';
import { ResourceItemDirective } from '../resource-item.directive';

@Component({
    selector: 'app-resource-builder-course',
    templateUrl: './course.component.html',
    styleUrls: ['./course.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseComponent extends ResourceItemDirective implements OnDestroy {
    public courses: Observable<Resource[]>;
    public filteredCourses: Observable<Resource[]>;

    constructor(
        protected resourceService: ResourceService,
        protected changeRef: ChangeDetectorRef,
        protected dialog: MatDialog,
        protected authService: AuthService,
        protected mobileService: MobileService,
        protected bottomSheet: MatBottomSheet
    ) {
        super(resourceService, changeRef, dialog, authService, mobileService, bottomSheet);
    }
}
